export const ListQueryKey = 'captainSalarys';
export const DetailQueryKey = 'captainSalary';

export const Urls = {
  selectUrl: '/captainSalary/list',
  updateUrl: '/captainSalary/update',
  deleteUrl: '/captainSalary/delete',
  createUrl: '/captainSalary/create',
  detailUrl: '/captainSalary/detail',
};
